import './hotspot-popup.sass'

export { default } from './PopupHotspot'
